<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Published Articles</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createArticle">Create Article</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="articles.columns" :data="articles.data">
                    <template slot="table-row" v-if="articles.data.length">
                        <tr v-for="(item, index) in articles.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.toneArticleId}}</td>
                            <td>{{item.datePublish}}</td>
                            <td>{{item.articleHead}}</td>
                            <td><a :href="makeOnlineUrl(item)">{{makeOnlineUrl(item)}}</a></td>
                            <td ><img class="table-thumbnail" :title="item.imageUrl":src="item.imageUrl" /></td>
                            <td>
                                <span class="badge badge-success" v-if="item.active"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewArticle(item)" v-tooltip.top-center="articles.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editArticle(item)" v-tooltip.top-center="articles.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const articleColumns = ['Article Id', 'Published Date', 'Title', 'URL', 'Image','Status', 'Operations'];
    export default {
        name: 'Articles',
        components: {
            LTable,
        },
        data() {
        return {
              articles: {
                tooltips: {
                    view: 'View Article',
                    edit: 'Edit Article',
                    delete: 'Inactivate Article',
                    activate:'Activate Article',
                },
                columns: [...articleColumns],
                tableRowClass: {
                    classname: 'badge-warning',
                    classActiveCondition: 'status'
                },
                data: []
    }
    }
    },
    methods: {
      makeOnlineUrl(item){
        let href = window.location.href;
        let origin = (href.indexOf('dev') !== -1) ? 'https://www1.dev-tonenetworks.com' : 'https://www.tonenetworks.com';
        if(item.corporationId !== 4) {
          return `${origin}/setthetone/article/${item.toneArticleId}/${item.articleHead.replace(/\s/g, '-').toLowerCase()}`
        }
      },
        fetchArticles () {
            this.$store.dispatch('FETCH_ARTICLES')
                    .then((res) => {
                      console.log('articles', res)
                        this.articles.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewArticle(article){
            console.log('article to view', article)
            this.$router.push({ name: 'ArticleDetail', params: { id: article.toneArticleId}})
        },
        editArticle(article){
            this.$router.push({ name: 'EditArticle', params: { id: article.toneArticleId}})
        },
        createArticle(){
            this.$router.push({ name: 'CreateArticle'})
        },
        deleteArticle(testimonial, boolean){
            console.log("testimonial : ", testimonial);
            this.$store.dispatch('DELETE_SELECTED_TESTIMONIAL', {testimonialId: testimonial.pkCarouselId})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchTestimonials();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        }
    },
    created() {
        this.fetchArticles();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Articles/Articles.vue